import React from 'react';

const NoDataFound = () => {
  return (
    <div className="text-center">
      <img src="/Image/Icons/nodata.png" className="no-data my-5 py-5" alt='nodata poster' />
    </div>
  );
};

export default NoDataFound;
